import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SocialTwitter = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29 8H25.658C24.823 5.64 22.561 4 20 4C16.724 4 14.053 6.639 14.001 9.903C10.265 9.176 7.894 4.553 7.894 4.553C7.73 4.226 7.392 4 7 4C6.653 4 6.347 4.177 6.168 4.445C6.168 4.445 4 7.746 4 12C4 14.497 5.33 16.606 6.529 18H5C4.448 18 4 18.448 4 19C4 20.926 4.974 22.718 6.742 24.044C8.424 25.306 10.647 26 13 26C20.027 26 25.77 20.395 25.993 13.421L29.707 9.707C29.888 9.526 30 9.276 30 9C30 8.448 29.552 8 29 8V8ZM24.293 12.293C24.105 12.481 24 12.735 24 13C24 19.065 19.065 24 13 24C9.62 24 6.791 22.279 6.141 20H9C9.552 20 10 19.552 10 19C10 18.674 9.843 18.385 9.601 18.202C9.601 18.202 6 15.44 6 12C6 9.967 6.57 8.198 7.074 7.029C7.423 7.529 7.862 8.102 8.388 8.675C10.381 10.85 12.668 11.999 15 11.999C15.552 11.999 16 11.551 16 10.999V9.999C16 7.793 17.794 5.999 20 5.999C21.895 5.999 23.544 7.344 23.92 9.198C24.015 9.664 24.424 9.999 24.9 9.999H26.586L24.293 12.292V12.293Z" />
	</svg>
);

export default SocialTwitter;
